import { z } from 'zod';
import { ProbeVendorSchema } from '../domain/probe.js';

export const DetectedProbeSchema = z.object({
  device_id: z.string(),
  name: z.string(),
  vendor: ProbeVendorSchema,
  model_hint: z.string().nullable().optional(),
  rssi: z.number().int().nullable().optional(),
  last_seen: z.string().datetime(),
});
export type DetectedProbe = z.infer<typeof DetectedProbeSchema>;

export const TempReadingSchema = z.object({
  device_id: z.string(),
  temperature_c: z.number(),
  humidity_pct: z.number().nullable().optional(),
  battery_pct: z.number().nullable().optional(),
  received_at: z.string().datetime(),
});
export type TempReading = z.infer<typeof TempReadingSchema>;

export interface BleProbeAdapter {
  readonly vendor: z.infer<typeof ProbeVendorSchema>;
  scan(timeoutMs?: number): Promise<DetectedProbe[]>;
  pair(device: DetectedProbe): Promise<{ paired_id: string }>;
  unpair(pairedId: string): Promise<void>;
  subscribe(pairedId: string, onReading: (reading: TempReading) => void): Promise<() => void>;
  readOnce(pairedId: string): Promise<TempReading>;
}
